const hasNavigator = typeof navigator !== 'undefined';
const hasDocument = typeof document !== 'undefined';
const hasWindow = typeof window !== 'undefined';

export default function getAssessmentBrowserSupport({ capturePhotos = false, captureScreens = false, ai = false } = {}) {
    const needsCamera = capturePhotos || ai;
    const needsScreenCapture = captureScreens && ai === false;
    const checks = [
        {
            key: 'screen-details',
            supported: hasWindow && typeof window.getScreenDetails === 'function',
        },
        {
            key: 'wake-lock',
            supported: hasNavigator && 'wakeLock' in navigator && typeof navigator.wakeLock.request === 'function',
        },
        {
            key: 'fullscreen',
            supported: hasDocument && !!document.documentElement && typeof document.documentElement.requestFullscreen === 'function',
        },
        {
            key: 'permissions',
            supported: hasNavigator && 'permissions' in navigator && typeof navigator.permissions.query === 'function',
        },
        {
            key: 'media-devices',
            supported: hasNavigator && 'mediaDevices' in navigator && !!navigator.mediaDevices,
        },
        {
            key: 'user-media',
            supported: hasNavigator && 'mediaDevices' in navigator && !!navigator.mediaDevices && typeof navigator.mediaDevices.getUserMedia === 'function',
        },
    ];

    if (needsScreenCapture) {
        checks.push({
            key: 'display-media',
            supported: hasNavigator && 'mediaDevices' in navigator && !!navigator.mediaDevices && typeof navigator.mediaDevices.getDisplayMedia === 'function',
        });
    }

    if (needsCamera || needsScreenCapture) {
        checks.push({
            key: 'image-capture',
            supported: hasWindow && typeof window.ImageCapture === 'function',
        });
    }

    return {
        supported: checks.every((check) => check.supported),
        checks,
    };
}
